import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardSell, TStringKeysOfIFillDataWizardSell } from "../..";
import { EDealRequestCommunicationType } from "../../../../../../shared/wizard/steps/types";
import sellSteps from "../sellSteps";
import CommunicateStep from "../../../../../../shared/wizard/steps/communicateStep";

interface IKnowPriceStep_2 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IKnowPriceStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_1);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_3);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default KnowPriceStep_2;
